<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">TP Benchmark Terms of Use</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body ey-privacy-notice-body">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <p class="header"></p>
        <div class="body">
          <p>
            If the vendor database provides the business description of potentially comparable companies in the local language only, the tool uses
            Microsoft Translator to automatically translate the business description to English. The tool does not enable EY professionals to amend or
            otherwise modify the translation prepared / provided by Microsoft Translator. EY professionals must not independently validate the
            translation outside of the tool if the client is either a US SEC restricted audit client (including affiliates) or a Listed PIE audit
            client (including affiliates).
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <p class="header">Contact us</p>
        <div class="body">
          <p>If you have any questions or concerns, please email <a href="mailto:global.data.protection@ey.com">global.data.protection@ey.com</a>.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
  <button type="button" class="btn btn-primary" [disabled]="!isActive" (click)="acknowledge()" title="Please scroll to the bottom to acknowledge.">
    Acknowledge
  </button>
</div>
